import { createAction } from '@reduxjs/toolkit';

export const NAV_STACK_BACK_ACTION_TYPE = 'saga/navStackBack';
export const navStackBackAction = createAction(NAV_STACK_BACK_ACTION_TYPE);
